module.exports = __webpack_public_path__ + "img/2018-09-3.ab88eeb2.jpeg";